module.exports = __webpack_public_path__ + "32da5dd806adf86530e920b5203a5ad0.svg";